<template>
    <ul
        class="comment-textarea-handler pa-group pa-absolute pa-z-10 -pa-top-[7px] pa-translate-x-1/2 pa-right-1/2 pa-w-14 pa-h-3.5 pa-rounded-xl pa-flex pa-flex-col pa-items-center pa-justify-center pa-gap-0.5 pa-cursor-row-resize pa-bg-grey-30 hover:pa-bg-green-500"
        @mousedown="handleMouseDown"
    >
        <li class="pa-bg-grey-90 group-hover:pa-bg-white pa-w-4 pa-h-0.5" />
        <li class="pa-bg-grey-90 group-hover:pa-bg-white pa-w-4 pa-h-0.5" />
    </ul>
</template>

<script setup lang="ts">
import _ from 'lodash';
import { onBeforeUnmount, onMounted, } from 'vue';
import { useCacheCommentTextareaHeight } from './composables/use-cache-comment-textarea-height';
import { useFixHeight } from './composables/use-fix-height';

function getCommentFooter () {
    return document.querySelector('.comment-footer') as HTMLElement;
}

function getCommentFooterHeight () {
    const commentFooter = getCommentFooter();
    return commentFooter.offsetHeight;
}

const {
    saveHeightToCache,
    getHeightFromCache,
} = useCacheCommentTextareaHeight();

function updateCommentFooterHeight (height: number) {
    const commentFooter = getCommentFooter();
    if (commentFooter) {
        commentFooter.style.height = `${height}px`;
    }
}

let lastHeight = 0;
let lastY = -1;

const { fixHeight } = useFixHeight();

function handleMouseMove (e: MouseEvent) {
    e.preventDefault();
    const y = e.clientY;
    if (lastY !== -1) {
        const offsetY = y - lastY;
        const height = fixHeight(lastHeight - offsetY);
        updateCommentFooterHeight(height);
    }
}

const disposes: (() => void)[] = [];

function dispose () {
    disposes.forEach(dispose => dispose());
}

function handleMouseUp() {
    const height = getCommentFooterHeight();
    saveHeightToCache(height);
    dispose();
}

function handleMouseDown (e: MouseEvent) {
    lastY = e.clientY;
    lastHeight = getCommentFooterHeight();
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    disposes.push(() => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    });
}

onMounted(() => {
    const height = getHeightFromCache();
    updateCommentFooterHeight(fixHeight(height));
});

function resetCommentFooterHeight () {
    const commentFooter = getCommentFooter();
    if (commentFooter) {
        commentFooter.style.height = '';
    }
}

onBeforeUnmount(() => {
    dispose();
    resetCommentFooterHeight();
});
</script>
